import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { IconComponent, TooltipDirective } from '@mode/capra';
import { TabFooterComponent } from '../tab-footer/tab-footer.component';

@Component({
  standalone: true,
  selector: 'mode-metadata-summary',
  imports: [CommonModule, IconComponent, TabFooterComponent, TooltipDirective],
  templateUrl: './metadata-summary.component.html',
  styleUrls: ['./metadata-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MetadataSummaryComponent implements OnChanges {
  @Input({ required: true }) spreadsheetName = '';
  @Input({ required: true }) spreadsheetUrl = '';
  @Input({ required: true }) worksheetName = '';
  @Input({ required: true }) worksheetRange = '';
  @Input({ required: true }) ownedBy = '';
  @Input({ required: true }) connectedBy = '';
  @Input({ required: true }) lastSynced = '';
  @Input({ required: true }) lastSyncedBy = '';

  tooltipUrl = '';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['spreadsheetUrl']?.currentValue) {
      this.tooltipUrl = `<p style="margin: 0; word-break: break-all;">${changes['spreadsheetUrl'].currentValue}</p>`;
    }
  }
}
